import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Switch from "@mui/material/Switch";
import { useGame, useMyEntitlements, useUpdateGameV2 } from "@seabrookstudios/pitch2table";
import CircularProgress from "@mui/material/CircularProgress";
import { LockedListItemText } from "../core/HasEntitlements";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const GameFeedbackControl = ({ gameId }) => {
  const updateGame = useUpdateGameV2(gameId);
  const { data: game } = useGame(gameId);
  const { data: entitlements } = useMyEntitlements();

  /**
   * @param {boolean} feedbackEnabled
   */
  const updateFeedbackEnabled = async (feedbackEnabled) => {
    await updateGame.mutateAsync({
      feedbackEnabled,
      sizzle: undefined,
      bgg: undefined,
      personalGoal: undefined,
      customAuthors: undefined,
      gameType: undefined,
      referenceId: undefined,
      tags: undefined,
    });
  };

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  const onChangeHandler = async (e) => {
    await updateFeedbackEnabled(e.target.checked);
  };

  if (!game || !entitlements) {
    return <CircularProgress />;
  }

  if (!entitlements.isMember) {
    return (
      <LockedListItemText
        primary="Feedback"
        secondary="Allow players to send feedback about this game. Upgrade to enable this feature."
      />
    );
  }

  return (
    <ListItem>
      <ListItemText
        primary="Feedback"
        secondary={
          game.feedbackEnabled
            ? "Enabled - People with access to the feedback link can send you feedback about this game."
            : "Disabled - All feedback is blocked."
        }
      />
      <ListItemButton style={{ justifyContent: "flex-end" }}>
        <Switch defaultChecked={game.feedbackEnabled} onChange={onChangeHandler} />
      </ListItemButton>
    </ListItem>
  );
};
